import manageJss from "@microsoft/fast-jss-manager-react";
import { Container as BaseContainer, containerStyleSheet, } from "./container";
const Container = manageJss(containerStyleSheet)(BaseContainer);
export { Container, };
